import { ASSIGNMENT_STATUS, ENTITY_TYPE } from "./constants";
import { getSchoolAssignments } from "./getAssignment/getAssignment";
import { updateBatchAssignments } from "./updateBatchAssignments";
import { getDefaultTemplates } from "./getAssignmentTemplate";
import { addAssignment } from "./addAssignment/addAssignment";
import { cleanManifest } from "./manifest";

export async function getSchoolWindow(schoolId){

  let assignments = await getSchoolAssignments(schoolId);
  return assignments.filter(assignment=>assignment.status === ASSIGNMENT_STATUS.ASSIGNED);
}

export async function unassignSchoolAssignments(schoolId){
  let assignments = await getSchoolAssignments(schoolId);
  if(assignments.length){
    const assignmentIds = assignments.map((assignment)=>assignment.assignmentId);
    if(assignmentIds.length){
      let batchInput = assignmentIds.map((id)=>{
        return {
          entityId: schoolId,
          entityType: ENTITY_TYPE.SCHOOL,
          assignmentId: id,
          status: ASSIGNMENT_STATUS.UNASSIGNED
        }
      });
      await updateBatchAssignments(batchInput);
    }
  }
}

export async function updateSchoolScreeningWindow(schoolId, dateStart, dateEnd){
  const requestResults = await Promise.all([unassignSchoolAssignments(schoolId),getDefaultTemplates(schoolId, ENTITY_TYPE.SCHOOL)]);

  let placeholderTemplate = requestResults[1][3];
  placeholderTemplate.manifest = cleanManifest(placeholderTemplate.manifest);

  let assignment = {
    assignmentType: "BENCHMARK",
    dateFrom: dateStart,
    dateTo: dateEnd,
    entityId: schoolId,
    entityType: ENTITY_TYPE.SCHOOL,
    manifest: placeholderTemplate.manifest,
    status: ASSIGNMENT_STATUS.ASSIGNED
  }

  let resp = await addAssignment(assignment);
  return resp;
}